import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { MessageItem } from '@/types/MessagingInterfaces';
import { formatTime, getInitials } from './messagingUtils';

interface MessageBubbleProps {
    message: MessageItem;
    authUserId: number;
}

export const MessageBubble = ({ message, authUserId }: MessageBubbleProps) => {
    const isOwn = message.sender_user_id === authUserId;

    return (
        <div className={`flex gap-3 ${isOwn ? 'flex-row-reverse' : 'flex-row'}`}>
            <Avatar className="h-8 w-8 flex-shrink-0">
                <AvatarImage src={message.sender.avatar_url ?? undefined} />
                <AvatarFallback className="text-xs">
                    {getInitials(message.sender)}
                </AvatarFallback>
            </Avatar>
            <div className={`max-w-[75%] space-y-1 flex flex-col ${isOwn ? 'items-end' : 'items-start'}`}>
                <div className={`rounded-2xl px-4 py-2 text-sm ${
                    isOwn
                        ? 'bg-primary text-primary-foreground rounded-tr-sm'
                        : 'bg-muted rounded-tl-sm'
                }`}>
                    {message.body}
                </div>
                <span className="text-xs text-muted-foreground px-1">
                    {formatTime(message.created_at)}
                </span>
            </div>
        </div>
    );
};
